exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sJVKo{position:relative;width:100%;padding-bottom:60%;overflow:hidden;border-radius:var(--base--border-radius);border-radius:var(--base--border-radius)}.sJVKo ._13ZYz{position:absolute;width:100%;-webkit-transform:translate(-50%, -50%);-ms-transform:translate(-50%, -50%);transform:translate(-50%, -50%);left:50%;top:50%}", ""]);

// exports
exports.locals = {
	"imageContainer": "sJVKo",
	"image": "_13ZYz"
};